// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"dffa43b5d2dfe829","573":"f6fa1f71020552ab"}[chunkId] + ".css";
};